export const NAV_WIDTH = 220;
export const HEADER_HEIGHT = 46;
